// extracted by mini-css-extract-plugin
module.exports = {"square":"Badge_square__2fI5a"};